import { useAcademy } from '@/components/academy/AcademyProvider';
import { Button } from '@/components/ui/button';
import { FileText, Eye, Download } from 'lucide-react';

export function AcademyDocuments() {
  const { content, openPdf } = useAcademy();
  return (
    <section data-testid="academy-documents">
      <h2 className="font-chivo font-black text-lg text-navy dark:text-white">Guider och dokument</h2>
      <p className="text-xs text-slate-400 font-ibm mt-0.5 mb-4">Öppna i webbläsaren eller ladda ner som PDF för utskrift.</p>
      <div className="grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
        {content.documents.map(doc => (
          <div key={doc.slug} className="group rounded-xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 p-4 flex flex-col hover:border-slate-300 hover:shadow-sm transition-shadow" data-testid={`academy-doc-${doc.slug}`}>
            <div className="flex items-start gap-3">
              <div className="h-10 w-8 rounded-sm bg-navy flex items-center justify-center shrink-0 relative">
                <FileText className="h-4 w-4 text-white" />
                <span className="absolute -bottom-1 -right-1 text-[8px] font-bold bg-red-500 text-white px-1 rounded-sm">PDF</span>
              </div>
              <div className="min-w-0">
                <h3 className="font-ibm font-semibold text-sm text-navy dark:text-white leading-tight">
                  {doc.title === 'Vapelarm Cloud' ? doc.subtitle : doc.title}
                </h3>
                <p className="text-xs text-slate-400 font-ibm mt-1 line-clamp-2">{doc.description}</p>
              </div>
            </div>
            <p className="text-[11px] text-slate-400 font-ibm mt-3" data-testid={`academy-doc-version-${doc.slug}`}>
              Version {doc.version} · Uppdaterad {doc.updated}
            </p>
            <div className="flex gap-2 mt-3">
              <Button size="sm" variant="outline" className="flex-1 text-xs" onClick={() => openPdf(doc.slug)} data-testid={`academy-doc-open-${doc.slug}`}>
                <Eye className="h-3.5 w-3.5 mr-1" />Öppna
              </Button>
              <Button size="sm" className="flex-1 text-xs bg-navy hover:bg-navy/90" onClick={() => openPdf(doc.slug, true)} data-testid={`academy-doc-download-${doc.slug}`}>
                <Download className="h-3.5 w-3.5 mr-1" />Ladda ner
              </Button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
